let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("41Zns")).then(() => parcelRequire('2jwi6'));